import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from '../BaseApi';

const CompanyEmployeesSlice = createSlice({
    name: 'companyEmployees',
    initialState: {
        companyEmployeesList: [],
        singleEmployeeDetail: {},
        singleEmployeeWithId: {},
        employeeRoles: [],
        employeeWorkStations: [],
        allUserByUserTypeIdList: [],
        employeeDepartments: [],
        hasSelfiData: [],
        selfieImage: null,
        employeeDocumentsList: [],
        employeeVehiclesList: [],
        fireArmStatus: [],
        singleFireArm: [],
        userInfoStatusList: [],
        contractStatusList: [],
        resetUnlockedAccount: null
    },
    reducers: {
        singleFireArmRefresh: (state, action) => {
            state.singleFireArm = action.payload;
        },
        handleSelfi: (state, action) => {
            state.singleFireArm = action.payload;
        },
        handleSelfieImage: (state, action) => {
            state.selfieImage = null;
        },
    },
    extraReducers: {
        'companyEmployees/getSingleEmployeeDetail/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.singleEmployeeDetail = data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to fetch data");
            }
        },
        'companyEmployees/getSingleEmployeeWithId/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.singleEmployeeWithId = data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to fetch data");
            }
        },
        'companyEmployees/getRoles/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeeRoles = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/getWorkStations/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeeWorkStations = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/getDepartments/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeeDepartments = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/addWorkShift/fulfilled': (state, action) => {
            const { status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_added_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/addCustomWorkShift/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_added_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/qrCodeByEmail/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_sent_successfully'));
            } else if (status >= 400 && status < 600) {
                toast.error(t('error_sending'));
            }
        },
        'companyEmployees/resetByAttemps/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_sent_successfully'));
            } else if (status >= 400 && status < 600) {
                toast.error(t('error_sending'));
            }
        },
        'companyEmployees/resetUnlockedAccount/fulfilled': (state, action) => {
            state.resetUnlockedAccount = ResponseApi(action.payload)
        },
        'companyEmployees/unlinkDevice/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success('Device unLinked Succssfully..!');
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/hasSelfi/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.hasSelfiData = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/createImgObj/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },

        'companyEmployees/getSelfie/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/updateUser/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/updateUserEmployee/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(data?.message);
            } else if (status >= 400 && status < 500) {
                toast(data?.message);
            }
        },
        'companyEmployees/updateExtraData/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/documentListing/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeeDocumentsList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/employeeVehicles/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeeVehiclesList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/checkFireArms/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                if (data === false) {
                    toast.success('No FireArms..!');
                }
                state.fireArmStatus = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong'));
            }
        },
        'companyEmployees/getFireArm/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.singleFireArm = data;
            } else if (status >= 400 && status < 500) {
                // toast("something went in Wrong in getting FireArms..!")
            }
        },
        'companyEmployees/userInfoStatus/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.userInfoStatusList = data;
            } else if (status >= 400 && status < 500) {
                toast(status?.message);
            }
        },
        'companyEmployees/approveDocs/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('success'));
            } else if (status >= 400 && status < 500) {
                toast(data?.message);
            }
        },
        'companyEmployees/getAllUserByUserTypeId/fulfilled': (state, action) => {
            const {data: { data }, status,} = action.payload || {};
            if (status >= 200 && status < 300) {
                state.allUserByUserTypeIdList = data;
            }
        },
    },
});

export const { singleFireArmRefresh, handleSelfi, handleSelfieImage } = CompanyEmployeesSlice.actions;

export default CompanyEmployeesSlice.reducer;
